import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Table,
	Spinner,
	Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";
import { ToWords } from "to-words";

// import "../app-invoice.css";
import {
	getPendingPODocReport,
	getPODocReport,
	getConsumpptionDetailReport,
	getVendorDueDetailReport,
} from "../../../store/Reports/actions";
import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import LoadingModel from "../../LoadingModel";

class POReportDetailedDocument extends Component {
	constructor(props) {
		super(props);
		this.state = { amountInWords: "" };
	}

	componentDidMount() {
		const Poid = this.props.match.params.Poid;
		const query = new URLSearchParams(this.props.location.search);
		const otherId = query.get("otherId");
		this.props.getPODocReport(this.props.match.params.id, this.props.POPdf);
		this.props.getPendingPODocReport(otherId, this.props.POPdf);
		this.props.getConsumpptionDetailReport(
			this.props.match.params.id,
			this.props.POPdf
		);
		this.props.getVendorDueDetailReport(otherId, this.props.POPdf);
	}

	// getPDFReport() {
	// 	const codewidth = document.getElementById("fullPdfContent").style.width;
	// 	document.getElementById("fullPdfContent").style.width = "300mm";

	// 	const doc = new jsPDF("l", "mm", [297, 210]);
	// 	doc.setDisplayMode(1);

	// 	doc.html(document.getElementById("fullPdfContent"), {
	// 		callback: function (doc) {
	// 			doc.save();
	// 			document.getElementById("fullPdfContent").style.width =
	// 				codewidth;
	// 		},
	// 		x: 0,
	// 		y: 0,
	// 		html2canvas: { scale: 0.25 },
	// 	});
	// }
	getPDFReport = async () => {
		try {
			this.setState({ isGeneratingPDF: true });

			const element = document.getElementById("fullPdfContent");
			if (!element) return;

			const originalWidth = element.style.width;
			element.style.width = "297mm";
			element.style.maxWidth = "290mm";

			const pdf = new jsPDF("p", "mm", "a4");
			const pageWidth = pdf.internal.pageSize.getWidth();
			const pageHeight = pdf.internal.pageSize.getHeight();

			// Safe settings that won't crash
			const canvas = await html2canvas(element, {
				scale: 0.6, // Keep it low to prevent crash
				useCORS: true,
				allowTaint: true,
				backgroundColor: "#ffffff",
				scrollX: 0,
				scrollY: 0,
				windowWidth: element.scrollWidth,
				windowHeight: element.scrollHeight,
				logging: false, // Disable logging for performance
				removeContainer: true, // Clean up after rendering
			});

			const imgData = canvas.toDataURL("image/png", 0.8); // Use JPEG for smaller size
			const imgWidth = pageWidth;
			const imgHeight = (canvas.height * imgWidth) / canvas.width;

			let heightLeft = imgHeight;
			let position = 0;

			pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;

			while (heightLeft > 0) {
				position -= pageHeight;
				pdf.addPage();
				pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
				heightLeft -= pageHeight;
			}

			pdf.save("Purchase_Order_Detail_Report.pdf");
			element.style.width = originalWidth;
		} catch (error) {
			console.error("PDF generation failed:", error);
			alert("PDF generation failed: " + error.message);
		} finally {
			this.setState({ isGeneratingPDF: false });
		}
	};

	// PendingPOTable() {
	// 	const pendingPO =
	// 		this.props.Pending_PO_Doc_Report?.POId?.pending_po || [];
	// 	console.log("Total Pending PO rows:", pendingPO.length); // Debug line

	// 	return (
	// 		<Row className="p-1 report-preview">
	// 			<Col md={12} className="p-1">
	// 				<Card className="p-1 report-preview-card">
	// 					<CardBody className="report-padding pb-0">
	// 						<div className="report-body flex-sm-row flex-column  mt-0">
	// 							<div className=" ">
	// 								<h5 className="card-title-16 pt-2 ">
	// 									PENDING PO
	// 								</h5>
	// 							</div>
	// 						</div>

	// 						<div className="m-0">
	// 							{this.props.loading ? (
	// 								<div className="text-center">
	// 									<Spinner color="primary" />
	// 								</div>
	// 							) : (
	// 								<Table
	// 									// striped
	// 									bordered
	// 									// hover
	// 									className="mb-0 p-0 table-centered table-color-black">
	// 									<thead className="bg-light text-center">
	// 										<tr>
	// 											<th>S.NO</th>
	// 											<th>Created On</th>
	// 											<th>PO Code</th>
	// 											<th>RFQ Code</th>
	// 											<th>Vendor Name</th>
	// 											<th>Product Name</th>
	// 											<th>Original Qty</th>
	// 											<th>Store PV Qty</th>
	// 											<th>Balance Qty</th>
	// 											<th>Price</th>
	// 											<th>Gross</th>
	// 											<th>Pending Days</th>
	// 										</tr>
	// 									</thead>
	// 									<tbody>
	// 										{pendingPO?.map((item, key) => (
	// 											<tr key={key}>
	// 												<td className="text-center">
	// 													{key + 1}
	// 												</td>
	// 												<td className="nowrap text-center">
	// 													<h5 className="font-size-14 text-black ">
	// 														{item.createdon}
	// 													</h5>
	// 												</td>
	// 												<td>
	// 													<h5 className="font-size-14 text-black ">
	// 														{item.po_code}
	// 													</h5>
	// 												</td>
	// 												<td className="text-center">
	// 													{item.rfq_code}
	// 												</td>
	// 												<td className="text-center">
	// 													{item.vendor_name}
	// 												</td>
	// 												<td className="text-center">
	// 													{item.product_name}
	// 												</td>
	// 												<td className="text-center">
	// 													{item.originalqty}
	// 												</td>
	// 												<td className="text-center">
	// 													{item.store_pv_qty}
	// 												</td>
	// 												<td className="text-center">
	// 													{item.balance_qty}
	// 												</td>

	// 												<td className="text-center">
	// 													{item.price}
	// 												</td>
	// 												<td className="text-center">
	// 													{item.gross}
	// 												</td>
	// 												<td className="text-center">
	// 													{item.pending_days}
	// 												</td>
	// 											</tr>
	// 										))}
	// 									</tbody>
	// 								</Table>
	// 							)}
	// 						</div>
	// 					</CardBody>
	// 				</Card>
	// 			</Col>
	// 		</Row>
	// 	);
	// }

	PendingPOTable() {
		const pendingPO =
			this.props.Pending_PO_Doc_Report?.POId?.pending_po || [];

		return (
			<Row className="p-1 report-preview">
				<Col md={12} className="p-1">
					<Card className="p-1 report-preview-card">
						<CardBody className="report-padding pb-0">
							<div className="report-body flex-sm-row flex-column mt-0">
								<div>
									<h5 className="card-title-16 pt-2">
										PENDING PO ({pendingPO.length} items)
									</h5>
								</div>
							</div>

							<div className="m-0" style={{ overflowX: "auto" }}>
								{this.props.loading ? (
									<div className="text-center">
										<Spinner color="primary" />
									</div>
								) : (
									<Table
										bordered
										className="mb-0 p-0 table-centered table-color-black"
										style={{
											fontSize: "80px",
											minWidth: "100%",
											tableLayout: "fixed",
											width: "100%",
										}}>
										<thead className="bg-light text-center">
											<tr>
												<th
													style={{
														width: "4%",
														padding: "4px",
														fontSize: "14px",
													}}>
													S.NO
												</th>
												<th
													style={{
														width: "10%",
														padding: "4px",
														fontSize: "14px",
													}}>
													Created On
												</th>
												<th
													style={{
														width: "8%",
														padding: "4px",
														fontSize: "14px",
													}}>
													PO Code
												</th>
												<th
													style={{
														width: "8%",
														padding: "4px",
														fontSize: "14px",
													}}>
													RFQ Code
												</th>
												<th
													style={{
														width: "14%",
														padding: "4px",
														fontSize: "14px",
													}}>
													Vendor Name
												</th>
												<th
													style={{
														width: "15%",
														padding: "4px",
														fontSize: "14px",
													}}>
													Product Name
												</th>
												<th
													style={{
														width: "8%",
														padding: "4px",
														fontSize: "14px",
													}}>
													Orig Qty
												</th>
												<th
													style={{
														width: "8%",
														padding: "4px",
														fontSize: "14px",
													}}>
													Store Qty
												</th>
												<th
													style={{
														width: "8%",
														padding: "4px",
														fontSize: "14px",
													}}>
													Bal Qty
												</th>
												<th
													style={{
														width: "7%",
														padding: "4px",
														fontSize: "14px",
													}}>
													Price
												</th>
												<th
													style={{
														width: "7%",
														padding: "4px",
														fontSize: "14px",
													}}>
													Gross
												</th>
												<th
													style={{
														width: "5%",
														padding: "4px",
														fontSize: "14px",
													}}>
													Pending Days
												</th>
											</tr>
										</thead>
										<tbody>
											{pendingPO?.map((item, key) => (
												<tr key={key}>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
														}}>
														{key + 1}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
															wordWrap:
																"break-word",
														}}>
														{item.createdon}
													</td>
													<td
														style={{
															padding: "3px",
															fontSize: "13px",
															wordWrap:
																"break-word",
														}}>
														{item.po_code}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
															wordWrap:
																"break-word",
														}}>
														{item.rfq_code}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
															wordWrap:
																"break-word",
														}}>
														{item.vendor_name}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
															wordWrap:
																"break-word",
														}}>
														{item.product_name}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
														}}>
														{item.originalqty}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
														}}>
														{item.store_pv_qty}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
														}}>
														{item.balance_qty}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
														}}>
														{item.price}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
														}}>
														{item.gross}
													</td>
													<td
														className="text-center"
														style={{
															padding: "3px",
															fontSize: "13px",
														}}>
														{item.pending_days}
													</td>
												</tr>
											))}
										</tbody>
									</Table>
								)}
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}

	ConsumtionTable() {
		const consumption = this.props.Consumtion_Doc.POId || [];

		return (
			<Row className="p-1 report-preview">
				<Col md={12} className="p-1">
					<Card className="p-1 report-preview-card">
						<CardBody className="report-padding pb-0">
							<div className="report-body flex-sm-row flex-column  mt-0">
								<div className=" ">
									<h5 className="card-title-16 pt-2 ">
										Consumption
									</h5>
								</div>
							</div>

							<div className="m-0">
								{this.props.loading ? (
									<div className="text-center">
										<Spinner color="primary" />
									</div>
								) : (
									<Table
										// striped
										bordered
										// hover
										className="mb-0 p-0 table-centered table-color-black">
										<thead className="bg-light text-center">
											<tr>
												<th>Unit Name</th>
												<th>Department Name</th>
												<th>Issued Quantity</th>
											</tr>
										</thead>
										<tbody>
											{consumption?.map(
												(product, pIndex) => (
													<React.Fragment
														key={pIndex}>
														{/* Row spanning product name like title */}
														<tr>
															<td
																colSpan={7}
																style={{
																	fontWeight:
																		"bold",
																	textAlign:
																		"center",
																}}>
																{
																	product.product_name
																}
															</td>
														</tr>

														{product.consumption_table.map(
															(row, rIndex) => (
																<tr
																	key={
																		rIndex
																	}>
																	<td>
																		{
																			row.materialissue__location__name
																		}
																	</td>
																	<td>
																		{
																			row.materialissue__sublocation__name
																		}
																	</td>
																	<td
																		style={{
																			textAlign:
																				"right",
																		}}>
																		{row.originalqty.toFixed(
																			2
																		)}
																	</td>
																</tr>
															)
														)}
													</React.Fragment>
												)
											)}
										</tbody>
									</Table>
								)}
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}
	VendorDueTable() {
		const vendorDue = this.props.Vendor_Due_Report?.POId?.due_list || [];

		return (
			<Row className="p-1 report-preview">
				<Col md={12} className="p-1">
					<Card className="p-1 report-preview-card">
						<CardBody className="report-padding pb-0">
							<div className="report-body flex-sm-row flex-column  mt-0">
								<div className=" ">
									<h5 className="card-title-16 pt-2 ">
										VENDOR DUE List
									</h5>
								</div>
							</div>

							<div className="m-0">
								{this.props.loading ? (
									<div className="text-center">
										<Spinner color="primary" />
									</div>
								) : (
									<Table
										// striped
										bordered
										// hover
										className="mb-0 p-0 table-centered table-color-black">
										<thead className="bg-light text-center">
											<tr>
												<th>S.NO</th>
												<th>Invoice Date</th>
												<th>Invoice Number</th>
												<th>Customer</th>
												<th>Invoice Amount</th>
												<th>Balance Amount</th>
												<th>Unit</th>
											</tr>
										</thead>
										<tbody>
											{vendorDue?.map((item, key) => (
												<tr key={key}>
													<td className="text-center">
														{key + 1}
													</td>
													<td className="nowrap text-center">
														<h5 className="font-size-14 text-black ">
															{item.Invoice_Date}
														</h5>
													</td>
													<td>
														<h5 className="font-size-14 text-black ">
															{item.Invoice_No}
														</h5>
													</td>

													<td className="text-center">
														{item.Customer_Name}
													</td>
													<td className="text-center">
														{item.Invoice_Amount}
													</td>
													<td className="text-center">
														{item.Balance_Amount}
													</td>
													<td className="text-center">
														{item.Unit}
													</td>
												</tr>
											))}
										</tbody>
									</Table>
								)}
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}
	reportBody() {
		const toWords = new ToWords();
		return (
			<Row className="p-1 report-preview">
				<Col md={12} className="p-1">
					<Card className="p-1 report-preview-card">
						<CardBody className="report-padding pb-0">
							<div className="report-body flex-sm-row flex-column  mt-0">
								<div className=" ">
									<h5 className="card-title-16 pt-2 ">
										SRI LALITHA ENTERPRISES INDUSTRIES PVT.
										LTD
									</h5>
									<p className="card-title-14 pt-2 mb-0">
										Valuthimmapuram Road, PEDDAPURAM -
										533437, E.G. Dist. - AP
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Phone No.0884-2326661, 62, Mobile
										No.9494154547,
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Email: purchase@sleipl.com,
										lalitharice@gmail.com
									</p>
									<p className="card-title-14 pt-2">
										GSTIN : 37AAKCS3233N1ZX
									</p>
								</div>
								<div className="pt-2">
									<span className="p-4">
										<img
											className="img-fluid p-0"
											src={SLE_logo}
											alt="Logo"
											width="100"
											height="120"
										/>
									</span>
									<h4 className="report-title mb-0">
										PURCHASE ORDER{" "}
									</h4>
									<h5 className="report-title">
										<span className="report-number">
											#{this.props.PO_Doc_report.code}
										</span>
									</h5>
								</div>
							</div>
							<hr className="hr-black-color " />

							<div className="report-body flex-sm-row flex-column mt-0">
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Vendor Name:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PO_Doc_report.vendor
													?.name
											}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Vendor Location:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PO_Doc_report.vendor
													?.city
											}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Vendor Phone:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PO_Doc_report.vendor
													?.mobile
											}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Vendor GST:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PO_Doc_report.vendor
													?.gstno
											}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											RFD Code:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PO_Doc_report
													.requestforquotation_code
											}
										</p>
									</div>

									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Sub Location
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report
												.sublocation?.name
												? this.props.PO_Doc_report
														.sublocation?.name
												: ""}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Transport By
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report
												?.transport_by_name
												? this.props.PO_Doc_report
														.transport_by_name
												: ""}
										</p>
									</div>
								</div>
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Prepared Date:
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report.createdon}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Quotation Code:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PO_Doc_report
													.quotation_code
											}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Quotation Date:
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report
												.quotation_date && (
												<>
													{moment(
														this.props.PO_Doc_report
															.quotation_date
													).format("DD-MM-YYYY")}
												</>
											)}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											PO Location:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PO_Doc_report
													.location?.name
											}
										</p>
									</div>

									<div className="report-wrapper">
										<p className="report-wrapper-title">
											PO Type:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PO_Doc_report
													.purchase_type_name
											}
										</p>
									</div>

									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Cost Center Type:
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report
												.sublocation
												?.cost_center_type_name
												? this.props.PO_Doc_report
														.sublocation
														?.cost_center_type_name
												: ""}
										</p>
									</div>
								</div>
							</div>
							<hr className="hr-black-color " />
							<div className="m-0">
								{this.props.loading ? (
									<div className="text-center">
										<Spinner color="primary" />
									</div>
								) : (
									<Table
										// striped
										bordered
										// hover
										className="mb-0 p-0 table-centered table-color-black">
										<thead className="bg-light text-center">
											<tr>
												<th style={{ width: "2%" }}>
													S.NO
												</th>
												<th style={{ width: "13%" }}>
													Item Image
												</th>
												<th style={{ width: "33%" }}>
													Item Name
												</th>
												<th style={{ width: "9%" }}>
													Quantity / Units
												</th>
												<th style={{ width: "9%" }}>
													Item Base Price
												</th>
												<th style={{ width: "4%" }}>
													Item Discount(%)
												</th>
												<th style={{ width: "9%" }}>
													Item Price
													<br />
													<sup>(Discount)</sup>
												</th>
												<th style={{ width: "4%" }}>
													Tax Type (%)
												</th>
												<th style={{ width: "8%" }}>
													Tax Amount
												</th>

												<th style={{ width: "9%" }}>
													Gross Value
												</th>
											</tr>
										</thead>
										<tbody>
											{this.props.PO_Doc_report?.poitems?.map(
												(item, key) => (
													<tr key={key}>
														<td className="text-center">
															{key + 1}
														</td>
														<td className="nowrap text-center">
															<div className="product-detail text-center">
																<img
																	src={
																		item
																			?.product
																			.image ==
																		null
																			? DefaultImg
																			: item
																					?.product
																					.image
																	}
																	alt="product-img"
																	title="product-img"
																	className="product-img  img-fluid mx-auto tab-img rounded"
																	style={{
																		height: "50px",
																		width: "80px",
																	}}
																	loading="lazy"
																/>
															</div>
														</td>
														<td>
															<h5 className="font-size-14 text-black ">
																{
																	item
																		?.product
																		?.name
																}
															</h5>
															<p className="mb-0 text-black">
																<b>Make :</b>{" "}
																<span className="font-weight-medium  text-black">
																	{item.make}
																</span>
															</p>
															<p className="mb-0 text-black">
																<b>
																	Description
																	:,
																</b>{" "}
																<span className="font-weight-medium  text-black">
																	{
																		item.description
																	}
																</span>
															</p>
															<p className="mb-0">
																<b>
																	Specifications
																	:
																</b>{" "}
																<br />
																{item.product
																	.description !==
																null ? (
																	<span
																		className="font-weight-medium font-size-12"
																		dangerouslySetInnerHTML={{
																			__html: item.product.description.replaceAll(
																				"\n",
																				"<br/>"
																			),
																		}}></span>
																) : (
																	<span className="font-weight-medium  font-size-12">
																		{
																			item
																				.product
																				.description
																		}
																	</span>
																)}
															</p>
															<p className="mb-0 text-black">
																<b
																	style={{
																		fontWeight: 800,
																	}}>
																	Item Group :
																</b>{" "}
																<span
																	style={{
																		fontWeight: 800,
																	}}
																	className="font-weight-medium text-black">
																	{
																		item
																			.product
																			?.group
																			?.name
																	}
																</span>
															</p>
															<p className="mb-0 text-black">
																<b
																	style={{
																		fontWeight: 800,
																	}}>
																	Highest
																	Price :
																</b>{" "}
																<span
																	style={{
																		fontWeight: 800,
																	}}
																	className="font-weight-medium text-black">
																	{
																		item.highest_baseprice
																	}
																	(
																	{
																		item
																			.highest_po_code
																			.pocode
																	}
																	)<br />(
																	{
																		item
																			.highest_po_code
																			?.vendor
																	}
																	)
																</span>
															</p>
															<p className="mb-0 text-black">
																<b
																	style={{
																		fontWeight: 800,
																	}}>
																	Highest Tax
																	Type:
																</b>{" "}
																<span
																	style={{
																		fontWeight: 800,
																	}}
																	className="font-weight-medium text-black">
																	{
																		item
																			.highest_po_code
																			.taxtype_name
																	}
																	(
																	{
																		item
																			.highest_po_code
																			.tax
																	}
																	)
																</span>
															</p>
															<p className="mb-0 text-black">
																<b
																	style={{
																		fontWeight: 800,
																	}}>
																	Lowest Price
																	:
																</b>{" "}
																<span
																	style={{
																		fontWeight: 800,
																	}}
																	className="font-weight-medium text-black">
																	{
																		item.lowest_baseprice
																	}
																	(
																	{
																		item
																			.lowest_po_code
																			.pocode
																	}
																	)<br />(
																	{
																		item
																			.lowest_po_code
																			?.vendor
																	}
																	)
																</span>
															</p>
															<p className="mb-0 text-black">
																<b
																	style={{
																		fontWeight: 800,
																	}}>
																	Lowest Tax
																	Type:
																</b>{" "}
																<span
																	style={{
																		fontWeight: 800,
																	}}
																	className="font-weight-medium text-black">
																	{
																		item
																			.lowest_po_code
																			.taxtype_name
																	}
																	(
																	{
																		item
																			.lowest_po_code
																			.tax
																	}
																	)
																</span>
															</p>
															<p className="mb-0 text-black">
																<b
																	style={{
																		fontWeight: 800,
																	}}>
																	Latest Price
																	:
																</b>{" "}
																<span
																	style={{
																		fontWeight: 800,
																	}}
																	className="font-weight-medium text-black">
																	{
																		item
																			.latest_vendor_baseprice
																			?.price
																	}
																	(
																	{
																		item
																			.latest_vendor_baseprice
																			?.pocode
																	}
																	)
																</span>
															</p>
															<p className="mb-0 text-black">
																<b
																	style={{
																		fontWeight: 800,
																	}}>
																	MR Codes :
																</b>{" "}
																<span
																	style={{
																		fontWeight: 800,
																	}}
																	className="font-weight-medium text-black">
																	{item.mr_codes
																		?.map(
																			(
																				c
																			) =>
																				c.code
																		)
																		.join(
																			", "
																		)}
																</span>
															</p>

															{item
																.poi_acknowledges
																.length !==
																0 && (
																<>
																	<p className="mb-0">
																		<b className="text-danger">
																			Acknowledge
																			:
																		</b>
																		<span className="font-weight-medium">
																			{
																				item
																					.poi_acknowledges[0]
																					.description
																			}
																		</span>
																	</p>
																	<p className="mb-0">
																		<b className="text-danger">
																			Acknowledge
																			By :
																		</b>
																		<span className="font-weight-medium">
																			{
																				item
																					.poi_acknowledges[0]
																					.createdby
																				// .fullname
																			}
																			{/* (
                                                                                                                  {
                                                                                                                        item
                                                                                                                              .poi_acknowledges[0]
                                                                                                                              .createdby
                                                                                                                        .username
                                                                                                                  }
                                                                                                                  ) */}
																		</span>
																	</p>
																</>
															)}
														</td>

														<td className="text-center">
															{item.qty}{" "}
															{item.unit?.name}
														</td>
														<td className="text-center">
															{item.baseprice}
														</td>
														<td className="text-center">
															{
																item.discountpercent
															}
															%
														</td>
														<td className="text-center">
															{item.price}
															<br />
															<sup>
																({item.discount}
																)
															</sup>
														</td>
														<td className="text-center">
															{parseInt(
																item.taxtype
															) === 1
																? "Inclusive"
																: "Exclusive"}{" "}
															({item.tax.name})
														</td>

														<td className="text-center">
															{item.taxamount}
														</td>
														<td className="text-center">
															{item.gross}
														</td>
													</tr>
												)
											)}
											<tr>
												<td
													className="text-left font-size-18"
													colSpan={9}>
													<b>Total</b>
												</td>
												<td className="text-center">
													{
														this.props.PO_Doc_report
															.total
													}{" "}
													{/* {this.state.amountInWords} */}
												</td>
											</tr>
										</tbody>
									</Table>
								)}
							</div>
							<hr className="hr-black-color " />
							<Row>
								<Col md={12}>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Amount In Words :
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report.total
												? toWords.convert(
														parseFloat(
															parseFloat(
																this.props
																	.PO_Doc_report
																	.total
															).toFixed(3)
														),
														{ currency: true }
												  )
												: ""}
										</p>
									</div>
								</Col>
							</Row>
							<hr className="hr-black-color " />

							<Row>
								<Col md={12}>
									<span className="TnCTitle mb-1">
										terms and conditions
									</span>
								</Col>
								<Col md={6} sm={6}>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Delivery:
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report.delivery}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Payment:
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report.payment}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											P & F:
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report.pnf}
										</p>
									</div>
								</Col>
								<Col md={6} sm={6}>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Transport
										</p>
										<p className="report-wrapper-det">
											{this.props.PO_Doc_report.transport}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											GST:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.PO_Doc_report
													.gstdetails
											}
										</p>
									</div>
								</Col>
							</Row>
							<hr className="hr-black-color " />
							{/* <Row>
                <Col md={12}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">{"Advance"}</p>
                    <p className="report-wrapper-det">
                      {this.props.PO_Doc_report.advance ? "Yes" : "No"}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " />
              <Row>
                <Col md={12}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">
                      {"Advance Percentage"}
                    </p>
                    <p className="report-wrapper-det">
                      {this.props.PO_Doc_report.advancepercentage}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " /> */}
							<Row>
								<Col md={12}>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											{"Remarks"}
										</p>
										<p className="report-wrapper-det">
											{this.props.pdfType == "internal"
												? this.props.PO_Doc_report
														.remarks
												: this.props.PO_Doc_report
														.externalremarks}
										</p>
									</div>
								</Col>
							</Row>
							<hr className="hr-black-color " />
							<Row>
								<Col md={12}>
									<div className="text-black">
										<ol>
											<li>
												The supplier has to file the GST
												returns regularly and ensure
												compliance to GST rules and
												regulations in respect of supply
											</li>
											<li>
												if we are denied ITC owing to
												your non-compliance, then we
												will recover the ITC amount
												along with interest, penalty
												etc. from your pending paymetns.
											</li>
										</ol>
										<p style={{ textIndent: "30px" }}>
											As per section 194Q TDS0.1% (of 5%
											if the buyer has not filed IT
											returns of two previour yeards) will
											be deducted on all purchase bills
											value exceeding fifty lack rupees in
											any previous year and hence supplier
											shall not charge TCS on Sales of
											goods as per section 206C (1H) @0.1%
										</p>
									</div>
								</Col>
							</Row>
							<hr className="hr-black-color " />
							<Row>
								<Col md={6}>
									<p className="text-black">
										Thanking you,
										<br /> Yours Faithfully
										<br />
										For SRI LALITHA ENTERPRISES INDUSTRIES
										PVT LTD.
									</p>
								</Col>
								{/* <Col md={6}>
                                                      <div className="float-right">
                                                            <div className="report-wrapper">
                                                                  <p className="report-wrapper-title">
                                                                        Prepared by:
                                                                  </p>
                                                                  <p className="report-wrapper-det">
                                                                        {this.props.PO_Doc_report[
                                                                              "Created By"
                                                                        ] && (
                                                                              <>
                                                                                    {
                                                                                          this.props
                                                                                                .PO_Doc_report[
                                                                                                "Created By"
                                                                                          ]

                                                                                           ?.fullname
                                                                                    }{" "}
                                                                                    (
                                                                                    {
                                                                                          this.props
                                                                                                .PO_Doc_report
                                                                                                .createdby
                                                                                                ?.fullname
                                                                                    }
                                                                                    )
                                                                                    {this.props.PO_Doc_report.createdby?.fullname}
                                                                              </>
                                                                        )}
                                                                  </p>
                                                            </div>
                                                      </div>
                                                </Col> */}
								<Col md={6}>
									<div className="float-right">
										<div className="report-wrapper">
											<p className="report-wrapper-title">
												Prepared by:
											</p>
											{this.props.PO_Doc_report?.createdby
												?.fullname ? (
												<p className="report-wrapper-det">
													{
														this.props.PO_Doc_report
															.createdby.fullname
													}
												</p>
											) : (
												<p className="report-wrapper-det">
													—
												</p> // fallback if not available
											)}
										</div>
									</div>
								</Col>

								<Col md={12} className="mt-4">
									<spam className="mb-4 text-black">
										<b>Managing Director</b>
									</spam>
								</Col>
							</Row>
							<hr className="hr-black-color printme " />
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}
	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						{this.props.loading && (
							<LoadingModel OpenModel={this.props.loading} />
						)}
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom no-print ">
										<Link
											to="#"
											onClick={() =>
												this.props.history.goBack()
											}
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										{/* {this.props.POPdf ? (
                      <Link
                        to={"/PurchaseOrder/" + this.props.match.params.id}
                        
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    ) : (
                      <Link
                        to="/poreport"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    )} */}

										<div className="float-right">
											<div className="d-inline-block ">
												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														this.getPDFReport()
													}>
													<i className="ri-file-excel-2-line"></i>
													<span className="d-none d-inline-block ml-1">
														PDF
													</span>
												</Button>

												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														window.print()
													}>
													<i className="mdi  mdi-printer"></i>
													<span className="d-none d-inline-block ml-1">
														Print
													</span>
												</Button>
											</div>
										</div>
									</CardHeader>
									<CardBody
										className="pt-1 mr-auto mx-auto"
										id="fullPdfContent">
										{/* {this.reportBody()} */}
										<div id="fullPdfContent">
											{this.reportBody()}
										</div>
										<div
											id="consumptionPage"
											style={{
												pageBreakBefore: "always",
											}}>
											{this.ConsumtionTable()}
										</div>
										<div
											id="vendorDuePage"
											style={{
												pageBreakBefore: "always",
											}}>
											{this.VendorDueTable()}
										</div>
										<div
											id="pendingPoPage"
											style={{
												pageBreakBefore: "always",
											}}>
											{this.PendingPOTable()}
										</div>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const {
		PO_Doc_report,
		POPdf,
		loading,
		pdfType,
		Pending_PO_Doc_Report,
		Consumtion_Doc,
		Vendor_Due_Report,
	} = state.reports;
	return {
		PO_Doc_report,
		POPdf,
		loading,
		pdfType,
		Pending_PO_Doc_Report,
		Consumtion_Doc,
		Vendor_Due_Report,
	};
};

export default connect(mapStatetoProps, {
	getPODocReport,
	getPendingPODocReport,
	getConsumpptionDetailReport,
	getVendorDueDetailReport,
})(POReportDetailedDocument);
